<template>
  <div class="tile status--overall">
    <p class="text__bold text__center subheading">Request Status</p>
    <p class="flex__center tile--row">
      <span class="text__bold mr-10">Overall Status:</span>
      <span class="ml-10">{{ overallStatus }}</span>
    </p>
    <p v-if="overallStatus === 'Incomplete'" class="text__bold text__center">Areas Needing Attention</p>
    <div class="overall--tiles">
      <a
        v-for="service in incompleteServices"
        :key="service.name"
        class="link__none"
        :class="statusClass"
        :href="`#${service.name}`"
      >
        <span class="text__bold">{{ service.name }}</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: ["active"],
  computed: {
    overallStatus() {
      return this.active.status !== "finished" ? "Incomplete" : "All Complete";
    },
    statusClass() {
      return this.overallStatus === "Incomplete" ? "status--incomplete" : null;
    },
    incompleteServices() {
      return this.active.services.filter(service => {
        return !service.is_complete && service.active;
      });
    }
  }
};
</script>

<style scoped lang="scss">
</style>